"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.get = get;
exports.post = post;
exports.put = put;
exports.patch = patch;
exports.apiDelete = apiDelete;

var _normalizr = require("normalizr");

var _auth = _interopRequireDefault(require("../auth"));

var _headerConfig = _interopRequireDefault(require("../config/headerConfig"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

var errorAction = function errorAction(type, params, payload, status) {
  return {
    type: "".concat(type, "/error"),
    params: params,
    payload: payload,
    response: {
      body: payload,
      ok: false,
      status: status
    }
  };
};

var requestAction = function requestAction(type, params) {
  return {
    type: "".concat(type, "/request"),
    params: params
  };
};

var successAction = function successAction(type, params, payload, status) {
  return {
    type: "".concat(type, "/success"),
    params: params,
    payload: payload,
    response: {
      body: payload,
      ok: true,
      status: status
    }
  };
};

var standardHeaders = {
  Accept: 'application/json',
  'Content-Type': 'application/json'
};

function apiRequest(uri, method, type) {
  var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var data = arguments.length > 4 ? arguments[4] : undefined;
  var schema = arguments.length > 5 ? arguments[5] : undefined;
  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(dispatch, getState) {
      var ok, payload, status, authenticated, authorization, authHeaders, configuredHeaders, config, response;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              // Signal to redux that the request has started
              dispatch(requestAction(type, params));
              ok = false;
              status = -1;
              _context.prev = 3;
              _context.next = 6;
              return _auth["default"].isAuthenticated(getState());

            case 6:
              authenticated = _context.sent;

              if (authenticated) {
                _context.next = 10;
                break;
              }

              _auth["default"].login();

              throw new Error('User is not authenticated');

            case 10:
              _context.next = 12;
              return _auth["default"].getAuthorizationHeader(uri);

            case 12:
              authorization = _context.sent;
              authHeaders = authorization ? {
                authorization: authorization
              } : {};
              configuredHeaders = _headerConfig["default"].getDefaultHeaders();
              config = {
                method: method,
                body: typeof data !== 'undefined' ? JSON.stringify(data) : undefined,
                headers: _objectSpread(_objectSpread(_objectSpread({}, standardHeaders), authHeaders), configuredHeaders)
              }; // Make the actual request

              _context.next = 18;
              return fetch(uri, config);

            case 18:
              response = _context.sent;
              ok = response.ok;
              status = response.status;

              if (!(status !== 204)) {
                _context.next = 25;
                break;
              }

              _context.next = 24;
              return response.json();

            case 24:
              payload = _context.sent;

            case 25:
              if (ok) {
                // If the response is OK and there is a normalizr schema, then we normalize the JSON
                // $FlowExpectedError - Complaining about `NormalizeResult` not being compatible with undefined
                payload = schema && payload ? (0, _normalizr.normalize)(payload, schema) : payload; // Signal to redux that the request has succeeded

                dispatch(successAction(type, params, payload, status));
              } else {
                // Signal to redux that the request has failed
                dispatch(errorAction(type, params, payload, status));
              }

              _context.next = 32;
              break;

            case 28:
              _context.prev = 28;
              _context.t0 = _context["catch"](3);
              payload = _context.t0; // Signal to redux that the request has failed

              dispatch(errorAction(type, params, payload, status));

            case 32:
              return _context.abrupt("return", {
                params: params,
                payload: payload,
                response: {
                  body: payload,
                  ok: ok,
                  status: status
                }
              });

            case 33:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[3, 28]]);
    }));

    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();
}

function get(uri, type, params, schema) {
  return apiRequest(uri, 'GET', type, params, undefined, schema);
}

function post(uri, type, params, data, schema) {
  return apiRequest(uri, 'POST', type, params, data, schema);
}

function put(uri, type, params) {
  var data = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var schema = arguments.length > 4 ? arguments[4] : undefined;
  return apiRequest(uri, 'PUT', type, params, data, schema);
}

function patch(uri, type, params) {
  var data = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var schema = arguments.length > 4 ? arguments[4] : undefined;
  return apiRequest(uri, 'PATCH', type, params, data, schema);
}

function apiDelete(uri, type, params, schema) {
  return apiRequest(uri, 'DELETE', type, params, undefined, schema);
}